import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const AddQuestionnaireClient = (props) => {
  const [loading, setLoading] = useState(true);
  const [opt1, setOpt1] = useState("");
  const [opt2, setOpt2] = useState("");
  const [opt3, setOpt3] = useState("");
  const [opt4, setOpt4] = useState("");
  const [opt5, setOpt5] = useState("");
  const [opt6, setOpt6] = useState("");
  const [opt7, setOpt7] = useState("");
  const [opt8, setOpt8] = useState("");
  const [opt9, setOpt9] = useState("");
  const [opt10, setOpt10] = useState("");
  const [opt11, setOpt11] = useState("");
  const [opt12, setOpt12] = useState("");
  const [opt13, setOpt13] = useState("");
  const [opt14, setOpt14] = useState("");
  const [opt15, setOpt15] = useState("");
  const [opt16, setOpt16] = useState("");
  const [opt17, setOpt17] = useState("");
  const [opt18, setOpt18] = useState("");
  const [opt19, setOpt19] = useState("");
  const [opt20, setOpt20] = useState("");
  const [opt21, setOpt21] = useState("");
  const [opt22, setOpt22] = useState("");
  const [opt23, setOpt23] = useState("");
  const [opt24, setOpt24] = useState("");
  const [opt25, setOpt25] = useState("");
  const [opt26, setOpt26] = useState("");
  const [opt27, setOpt27] = useState("");
  const [opt28, setOpt28] = useState("");
  const [opt29, setOpt29] = useState("");

  const [optSKD1, setOptSKD1] = useState("");
  const [optSKD2, setOptSKD2] = useState("");
  const [optSKD3, setOptSKD3] = useState("");
  const [optSKD4, setOptSKD4] = useState("");
  const [optSKD5, setOptSKD5] = useState("");
  const [optSKD6, setOptSKD6] = useState("");
  const [optSKD7, setOptSKD7] = useState("");
  const [optSKD8, setOptSKD8] = useState("");
  const [optSKD9, setOptSKD9] = useState("");
  const [optSKD10, setOptSKD10] = useState("");
  const [optSKD11, setOptSKD11] = useState("");
  const [optSKD12, setOptSKD12] = useState("");
  const [optSKD13, setOptSKD13] = useState("");
  const [optSKD14, setOptSKD14] = useState("");
  const [optSKD15, setOptSKD15] = useState("");
  const [optSKD16, setOptSKD16] = useState("");
  const [optSKD17, setOptSKD17] = useState("");
  const [optSKD18, setOptSKD18] = useState("");
  const [optSKD19, setOptSKD19] = useState("");
  const [optSKD20, setOptSKD20] = useState("");
  const [optSKD21, setOptSKD21] = useState("");
  const [optSKD22, setOptSKD22] = useState("");
  const [optSKD23, setOptSKD23] = useState("");
  const [optSKD24, setOptSKD24] = useState("");
  const [optSKD25, setOptSKD25] = useState("");
  const [optSKD26, setOptSKD26] = useState("");
  const [optSKD27, setOptSKD27] = useState("");

  const [clientsData, setClientsData] = useState("");
  const [clientQuest, setClientQuest] = useState([]);
  const [mode, setMode] = useState("add");
  const [password, setPassword] = useState("");
  const [end, setEndd] = useState(false);
  const [client, setClient] = useState([]);

  const validatePayment = (e) => {
    return true;
    if (
      opt1.length > 0 &&
      opt3.length > 0 &&
      opt20.length > 0 &&
      opt5.length > 0 &&
      opt7.length > 0 &&
      opt10.length > 0 &&
      opt12.length > 0 &&
      opt14.length > 0 &&
      opt23.length > 0 &&
      opt16.length > 0 &&
      opt18.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkData = () => {
    const interval = setInterval(() => {
      if (props.clientsData.length > 0) {
        setLoading(false);
      }
    }, 1000);
    return () => clearInterval(interval);
  };

  const fetchClients = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsDataQuest", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsData(data);
        fetchClientId();
      })
      .catch((error) => {});
  };

  const fetchClientId = async () => {
    var body = {
      id: props.clientId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClient(data[0]);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = async () => {
    setLoading(true);
    fetchClients();
  };

  useEffect(() => {
    getData();
  }, []);

  const handleOpt1Change = (e) => {
    setOpt1(e.target.value);
  };

  const handleOpt2Change = (e) => {
    setOpt2(e.target.value);
  };

  const handleOpt3Change = (e) => {
    setOpt3(e.target.value);
  };

  const handleOpt4Change = (e) => {
    setOpt4(e.target.value);
  };

  const handleOpt5Change = (e) => {
    setOpt5(e.target.value);
  };

  const handleOpt6Change = (e) => {
    setOpt6(e.target.value);
  };

  const handleOpt7Change = (e) => {
    setOpt7(e.target.value);
  };

  const handleOpt8Change = (e) => {
    setOpt8(e.target.value);
  };

  const handleOpt9Change = (e) => {
    setOpt9(e.target.value);
  };

  const handleOpt10Change = (e) => {
    setOpt10(e.target.value);
  };

  const handleOpt11Change = (e) => {
    setOpt11(e.target.value);
  };

  const handleOpt12Change = (e) => {
    setOpt12(e.target.value);
  };

  const handleOpt13Change = (e) => {
    setOpt13(e.target.value);
  };

  const handleOpt14Change = (e) => {
    setOpt14(e.target.value);
  };

  const handleOpt15Change = (e) => {
    setOpt15(e.target.value);
  };

  const handleOpt16Change = (e) => {
    setOpt16(e.target.value);
  };

  const handleOpt17Change = (e) => {
    setOpt17(e.target.value);
  };

  const handleOpt18Change = (e) => {
    setOpt18(e.target.value);
  };

  const handleOpt19Change = (e) => {
    setOpt19(e.target.value);
  };

  const handleOpt20Change = (e) => {
    setOpt20(e.target.value);
  };

  const handleOpt21Change = (e) => {
    setOpt21(e.target.value);
  };

  const handleOpt22Change = (e) => {
    setOpt22(e.target.value);
  };

  const handleOpt23Change = (e) => {
    setOpt23(e.target.value);
  };

  const handleOpt24Change = (e) => {
    setOpt24(e.target.value);
  };

  const handleOpt25Change = (e) => {
    setOpt25(e.target.value);
  };

  const handleOpt26Change = (e) => {
    setOpt26(e.target.value);
  };

  const handleOpt27Change = (e) => {
    setOpt27(e.target.value);
  };

  const handleOpt28Change = (e) => {
    setOpt28(e.target.value);
  };

  const handleOpt29Change = (e) => {
    setOpt29(e.target.value);
  };

  const handleEditQuest = (e) => {
    setLoading(true);
    setMode("edit");
    setOpt1(clientQuest.opt1);
    setOpt2(clientQuest.opt2);
    setOpt3(clientQuest.opt3);
    setOpt4(clientQuest.opt4);
    setOpt5(clientQuest.opt5);
    setOpt6(clientQuest.opt6);
    setOpt7(clientQuest.opt7);
    setOpt8(clientQuest.opt8);
    setOpt9(clientQuest.opt9);
    setOpt10(clientQuest.opt10);
    setOpt11(clientQuest.opt11);
    setOpt12(clientQuest.opt12);
    setOpt13(clientQuest.opt13);
    setOpt14(clientQuest.opt14);
    setOpt15(clientQuest.opt15);
    setOpt16(clientQuest.opt16);
    setOpt17(clientQuest.opt17);
    setOpt18(clientQuest.opt18);
    setOpt19(clientQuest.opt19);
    setOpt20(clientQuest.opt20);
    setOpt21(clientQuest.opt21);
    setOpt22(clientQuest.opt22);
    setOpt23(clientQuest.opt23);
    setOpt24(clientQuest.opt24);
    setOpt25(clientQuest.opt25);
    setOpt26(clientQuest.opt26);
    setOpt27(clientQuest.opt27);
    setOpt28(clientQuest.opt28);
    setOpt29(clientQuest.opt29);
    setLoading(false);
  };

  const addQuest = async () => {
    if (validatePayment()) {
      var body = {
        clientId: props.clientId,
        opt1: opt1,
        opt2: opt2,
        opt3: opt3,
        opt4: opt4,
        opt5: opt5,
        opt6: opt6,
        opt7: opt7,
        opt8: opt8,
        opt9: opt9,
        opt10: opt10,
        opt11: opt11,
        opt12: opt12,
        opt13: opt13,
        opt14: opt14,
        opt15: opt15,
        opt16: opt16,
        opt17: opt17,
        opt18: opt18,
        opt19: opt19,
        opt20: opt20,
        opt21: opt21,
        opt22: opt22,
        opt23: opt23,
        opt24: opt24,
        opt25: opt25,
        opt26: opt26,
        opt27: opt27,
        opt28: opt28,
        opt29: opt29,
        optSKD1: optSKD1,
        optSKD2: optSKD2,
        optSKD3: optSKD3,
        optSKD4: optSKD4,
        optSKD5: optSKD5,
        optSKD6: optSKD6,
        optSKD7: optSKD7,
        optSKD8: optSKD8,
        optSKD9: optSKD9,
        optSKD10: optSKD10,
        optSKD11: optSKD11,
        optSKD12: optSKD12,
        optSKD13: optSKD13,
        optSKD14: optSKD14,
        optSKD15: optSKD15,
        optSKD16: optSKD16,
        optSKD17: optSKD17,
        optSKD18: optSKD18,
        optSKD19: optSKD19,
        optSKD20: optSKD20,
        optSKD21: optSKD21,
        optSKD22: optSKD22,
        optSKD23: optSKD23,
        optSKD24: optSKD24,
        optSKD25: optSKD25,
        optSKD26: optSKD26,
        optSKD27: optSKD27,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addClientQuestionnaire", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Klient wypełnił ankietę do sprawy " +
          clientsData.filter((el) => +el.id === +props.clientId)[0].petitioner,
        props.clientId
      );

      setEndd(true);
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleLogin = (e) => {
    setLoading(true);
    var data = clientsData.filter((el) => +el.id === +props.clientId)[0];

    if (password === data.quest_pass) {
      setMode("loged");
      setLoading(false);
    } else {
      MySwal.fire({
        icon: "error",
        title: "Nieprawidłowe",
        text: "hasło",
      }).then(async (result) => {
        setLoading(false);
      });
    }
  };

  const styleM = {
    marginBottom: "5vh",
  };

  const styleNM = {
    marginBottom: "0vh",
  };

  return (
    <div style={{ padding: "0" }} className="mainContainerAddClient">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          {mode !== "loged" ? (
            <>
              <div className="mainContainerLoginPage">
                <div className="logoBoxLogin">
                  <img
                    src="https://ftpeople.pl/wp-content/uploads/2022/12/logomain.png"
                    alt=""
                  />
                </div>
                <div className="inputContainerLogin">
                  <div className="inputBoxLogin">
                    <span style={{ fontSize: "2vw", fontWeight: "600" }}>
                      UZUPEŁNIJ ANKIETĘ DLA SPRAWY
                    </span>
                  </div>
                </div>
                <div style={{ marginTop: "0" }} className="inputContainerLogin">
                  <div className="inputBoxLogin">
                    <label id="loginLabel">Hasło</label>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    <button
                      className="loginButtonLogin"
                      value="yes"
                      onClick={handleLogin}
                    >
                      ZALOGUJ
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          {mode === "loged" ? (
            <>
              {end ? (
                <>
                  <div className="inputContainerLogin">
                    <div className="inputBoxLogin">
                      <span style={{ fontSize: "2vw", fontWeight: "600" }}>
                        Dziękujemy za wypełnienie ankiety. Zostało ona przesłana
                        do kancelarii. Można teraz zamknąć okno przeglądarki
                        internetowej.
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <div className="mainContainerLoginPage">
                  <div className="logoBoxLogin">
                    <img
                      src="https://ftpeople.pl/wp-content/uploads/2022/12/logomain.png"
                      alt=""
                    />
                  </div>

                  <p
                    style={{
                      fontSize: "2vw",
                      fontWeight: "400",
                      textTransform: "uppercase",
                      marginTop: "30px",
                    }}
                  >
                    ANKIETA DLA SPRAWY KLIENTA{" "}
                    <span style={{ color: "#00bdce", fontWeight: "600" }}>
                      {
                        clientsData.filter(
                          (el) => +el.id === +props.clientId
                        )[0].petitioner
                      }
                    </span>
                  </p>
                  {client.type === "sankcja kredytu darmowego" ? (
                    <>
                      <div
                        style={{ padding: "30px" }}
                        id="addPaymentIC"
                        className="inputContainer"
                      >
                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              1. Czy środki z umowy przeznaczono na cele
                              konsumpcyjne?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD1}
                              onChange={(e) => {
                                setOptSKD1(e.target.value);
                              }}
                            >
                              {!optSKD1 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                          {optSKD1 === "TAK" ? (
                            <>
                              <div className="inputCol_3">
                                <label>Jakie cele konsumpcyjne?</label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  id="url"
                                  name="url"
                                  value={optSKD2}
                                  onChange={(e) => {
                                    setOptSKD2(e.target.value);
                                  }}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>

                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              2. Czy środki z umowy przeznaczono na spłatę
                              poprzednich zobowiązań finansowych?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD3}
                              onChange={(e) => {
                                setOptSKD3(e.target.value);
                              }}
                            >
                              {!optSKD3 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                          {optSKD3 === "TAK" ? (
                            <>
                              <div className="inputCol_3">
                                <label>
                                  Na co przeznaczono poprzednie zobowiązania
                                  finansowe?
                                </label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  id="url"
                                  name="url"
                                  value={optSKD4}
                                  onChange={(e) => {
                                    setOptSKD4(e.target.value);
                                  }}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>

                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              3. Czy środki z umowy przeznaczono na cele
                              mieszkaniowe?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD5}
                              onChange={(e) => {
                                setOptSKD5(e.target.value);
                              }}
                            >
                              {!optSKD5 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                          {optSKD5 === "TAK" ? (
                            <>
                              <div className="inputCol_3">
                                <label>Jakie cele?</label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  id="url"
                                  name="url"
                                  value={optSKD6}
                                  onChange={(e) => {
                                    setOptSKD6(e.target.value);
                                  }}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>

                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              4. Czy środki z umowy przeznaczono na inne cele?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD7}
                              onChange={(e) => {
                                setOptSKD7(e.target.value);
                              }}
                            >
                              {!optSKD7 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                          {optSKD7 === "TAK" ? (
                            <>
                              <div className="inputCol_3">
                                <label>Proszę o szczegółową informację</label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  id="url"
                                  name="url"
                                  value={optSKD8}
                                  onChange={(e) => {
                                    setOptSKD8(e.target.value);
                                  }}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>

                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              5. Jeżeli umowa finansowała wcześniejsze
                              zobowiązania (kredyt/pożyczka konsolidacyjna),
                              prosimy wskazać, czy były one powiązane z
                              prowadzeniem działalności gospodarczej?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD9}
                              onChange={(e) => {
                                setOptSKD9(e.target.value);
                              }}
                            >
                              {!optSKD9 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                        </div>

                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              6. Czy w momencie zawierania umowy któryś z
                              kredytobiorców/pożyczkobiorców prowadził
                              działalność gospodarczą?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD10}
                              onChange={(e) => {
                                setOptSKD10(e.target.value);
                              }}
                            >
                              {!optSKD10 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                        </div>

                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              7. Czy umowa została przez Państwa spłacona w
                              całości?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD11}
                              onChange={(e) => {
                                setOptSKD11(e.target.value);
                              }}
                            >
                              {!optSKD11 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                        </div>

                        {optSKD11 === "TAK" ? (
                          <>
                            <div
                              style={{ marginTop: "5vh", marginBottom: "5vh" }}
                              className="inputBox"
                            >
                              <div className="inputCol_3">
                                <label>Kiedy została spłacona?</label>
                                <input
                                  className="textAreaNote"
                                  type="date"
                                  id="url"
                                  name="url"
                                  value={optSKD12}
                                  onChange={(e) => {
                                    setOptSKD12(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        {optSKD11 === "TAK" ? (
                          <>
                            <div
                              style={{ marginTop: "5vh", marginBottom: "5vh" }}
                              className="inputBox"
                            >
                              <div className="inputCol_3">
                                <label>
                                  Czy otrzymali Państwo od Kredytodawcy zwrot
                                  części prowizji/innych kosztów w związku z
                                  wcześniejszą spłatą umowy?{" "}
                                </label>
                                <select
                                  type="text"
                                  id="court"
                                  name="court"
                                  value={optSKD13}
                                  onChange={(e) => {
                                    setOptSKD13(e.target.value);
                                  }}
                                >
                                  {!optSKD13 ? (
                                    <option key={0} value="0">
                                      Wybierz...
                                    </option>
                                  ) : (
                                    ""
                                  )}
                                  <>
                                    <option key={"TAK"} value={"TAK"}>
                                      TAK
                                    </option>
                                    <option key={"NIE"} value={"NIE"}>
                                      NIE
                                    </option>
                                  </>
                                </select>
                              </div>
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        {optSKD11 === "TAK" ? (
                          <>
                            <div
                              style={{ marginTop: "5vh", marginBottom: "5vh" }}
                              className="inputBox"
                            >
                              <div className="inputCol_3">
                                <label>
                                  W jakiej wysokości została zwrócona prowizja i
                                  inne koszty?
                                </label>
                                <input
                                  className="textAreaNote"
                                  type="number"
                                  id="url"
                                  name="url"
                                  value={optSKD14}
                                  onChange={(e) => {
                                    setOptSKD14(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              8. Czy kredytobiorca ogłosił upadłość konsumencką?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD15}
                              onChange={(e) => {
                                setOptSKD15(e.target.value);
                              }}
                            >
                              {!optSKD15 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                        </div>

                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              9. Czy w okresie trwania umowy doszło do
                              zwolnienia któregokolwiek z
                              Kredytobiorców/Pożyczkobiorców z długu?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD16}
                              onChange={(e) => {
                                setOptSKD16(e.target.value);
                              }}
                            >
                              {!optSKD16 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                        </div>

                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              10. Czy w okresie trwania umowy doszło do
                              przystąpienia do długu przez innego
                              Kredytobiorcę/Pożyczkobiorcę?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD17}
                              onChange={(e) => {
                                setOptSKD17(e.target.value);
                              }}
                            >
                              {!optSKD17 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                        </div>

                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              11. Czy w trakcie trwania umowy nastąpił zgon
                              któregokolwiek z Kredytobiorców/Pożyczkobiorców?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD18}
                              onChange={(e) => {
                                setOptSKD18(e.target.value);
                              }}
                            >
                              {!optSKD18 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                        </div>

                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              12. W przypadku, gdy umowa została zawarta przez
                              Kredytobiorców/Pożyczkobiorców pozostających w
                              związku małżeńskim, prosimy wskazać czy
                              pozostawali w ustroju wspólności majątkowej?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD19}
                              onChange={(e) => {
                                setOptSKD19(e.target.value);
                              }}
                            >
                              {!optSKD19 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                                <option
                                  key={"NIE DOTYCZY"}
                                  value={"NIE DOTYCZY"}
                                >
                                  NIE DOTYCZY
                                </option>
                              </>
                            </select>
                          </div>
                        </div>

                        {optSKD19 === "TAK" ? (
                          <>
                            <div
                              style={{ marginTop: "5vh", marginBottom: "5vh" }}
                              className="inputBox"
                            >
                              <div className="inputCol_3">
                                <label>Od kiedy?</label>
                                <input
                                  className="textAreaNote"
                                  type="date"
                                  id="url"
                                  name="url"
                                  value={optSKD20}
                                  onChange={(e) => {
                                    setOptSKD20(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              13. W przypadku, gdy umowa została zawarta przez
                              Kredytobiorców/Pożyczkobiorców pozostających w
                              związku małżeńskim, prosimy wskazać czy
                              ustanowiono rozdzielność majątkową?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD22}
                              onChange={(e) => {
                                setOptSKD22(e.target.value);
                              }}
                            >
                              {!optSKD22 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                                <option
                                  key={"NIE DOTYCZY"}
                                  value={"NIE DOTYCZY"}
                                >
                                  NIE DOTYCZY
                                </option>
                              </>
                            </select>
                          </div>
                        </div>

                        {optSKD22 === "TAK" ? (
                          <>
                            <div
                              style={{ marginTop: "5vh", marginBottom: "5vh" }}
                              className="inputBox"
                            >
                              <div className="inputCol_3">
                                <label>Od kiedy?</label>
                                <input
                                  className="textAreaNote"
                                  type="date"
                                  id="url"
                                  name="url"
                                  value={optSKD23}
                                  onChange={(e) => {
                                    setOptSKD23(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        <div
                          style={{
                            marginTop: "5vh",
                            marginBottom: "5vh",
                          }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              14. Kto faktycznie spłacał kredyt/pożyczkę?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={optSKD21}
                              onChange={(e) => {
                                setOptSKD21(e.target.value);
                              }}
                            >
                              {!optSKD21 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option
                                  key={"Wszyscy kredytobiorcy/pożyczkobiorcy"}
                                  value={"Wszyscy kredytobiorcy/pożyczkobiorcy"}
                                >
                                  Wszyscy kredytobiorcy/pożyczkobiorcy
                                </option>
                                <option
                                  key={"Jeden kredytobiorca/pożyczkobiorca"}
                                  value={"Jeden kredytobiorca/pożyczkobiorca"}
                                >
                                  Jeden kredytobiorca/pożyczkobiorca
                                </option>
                              </>
                            </select>
                          </div>
                        </div>

                        <>
                          <div className="saveBoxAP">
                            <button
                              style={{ minWidth: "25%", fontSize: "1.5vw" }}
                              className="paymentMenuButton"
                              onClick={addQuest}
                            >
                              {"Wyślij"}
                            </button>
                          </div>
                        </>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{ padding: "30px" }}
                        id="addPaymentIC"
                        className="inputContainer"
                      >
                        <div
                          style={{ marginTop: "5vh", marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              1. Czy kredyt został przeznaczony na spłatę innych
                              zobowiązań finansowych? (np. inne kredyty
                              hipoteczne, inne kredyty gotówkowe)
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={opt1}
                              onChange={handleOpt1Change}
                            >
                              {!opt1 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>

                          {opt1 === "TAK" ? (
                            <>
                              <div className="inputCol_3">
                                <label>
                                  Wymień waluty tych kredytów/pożyczek oraz ich
                                  przeznaczenie
                                </label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  id="url"
                                  name="url"
                                  value={opt2}
                                  onChange={handleOpt2Change}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          style={{ marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              2. Cele mieszkaniowe (np. własne, dla rodziny)?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={opt3}
                              onChange={handleOpt3Change}
                            >
                              {!opt3 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                          {opt3 === "TAK" ? (
                            <>
                              <div className="inputCol_3">
                                <label>
                                  Jakie cele mieszkaniowe (np. dom, mieszkanie,
                                  działka budowlana, itp.)
                                </label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  id="url"
                                  name="url"
                                  value={opt4}
                                  onChange={handleOpt4Change}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          style={{ marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              3. Czy mieszkali Państwo w kredytowanej
                              nieruchomości?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={opt20}
                              onChange={handleOpt20Change}
                            >
                              {!opt20 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                          {opt20 === "TAK" ? (
                            <>
                              <div className="inputCol_3">
                                <label>W jakim okresie?</label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  id="url"
                                  name="url"
                                  value={opt21}
                                  onChange={handleOpt21Change}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          style={{ marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              4. Inne cele konsumpcyjne? - szczegóły
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={opt5}
                              onChange={handleOpt5Change}
                            >
                              {!opt5 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                          {opt5 === "TAK" ? (
                            <>
                              <div className="inputCol_3">
                                <label>Jakie?</label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  tid="url"
                                  name="url"
                                  value={opt6}
                                  onChange={handleOpt6Change}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          style={{ marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              5. Działalność gospodarcza - czy była prowadzona
                              lub zarejestrowana w kredytowanej nieruchomości?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={opt7}
                              onChange={handleOpt7Change}
                            >
                              {!opt7 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>

                          {opt7 === "TAK" ? (
                            <>
                              <div className="inputCol_2">
                                <div
                                  style={{ marginBottom: "20px" }}
                                  className="inputBox"
                                >
                                  <div
                                    style={{ width: "61%" }}
                                    className="inputCol_3"
                                  >
                                    <label>W jakim okresie?</label>
                                    <input
                                      className="textAreaNote"
                                      type="text"
                                      id="url"
                                      name="url"
                                      value={opt8}
                                      onChange={handleOpt8Change}
                                    />
                                  </div>
                                </div>
                                <div
                                  style={{ marginBottom: "20px" }}
                                  className="inputBox"
                                >
                                  <div
                                    style={{ width: "61%" }}
                                    className="inputCol_3"
                                  >
                                    <label>Jaki rodzaj działalności?</label>
                                    <input
                                      className="textAreaNote"
                                      type="text"
                                      id="url"
                                      name="url"
                                      value={opt9}
                                      onChange={handleOpt9Change}
                                    />
                                  </div>
                                </div>
                                <div className="inputBox">
                                  <div
                                    style={{ width: "61%" }}
                                    className="inputCol_3"
                                  >
                                    <label>
                                      Na czym dokładnie polegała działalność?
                                      Czy była zarejestrowana wyłącznie do celów
                                      ewidencyjnych czy rzeczywiście prowadzona
                                      w kredytowanej nieruchomości?
                                    </label>
                                    <textarea
                                      className="textAreaNote"
                                      type="text"
                                      id="url"
                                      name="url"
                                      value={opt22}
                                      onChange={handleOpt22Change}
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          style={{ marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>6. Czy lokal był wynajmowany?</label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={opt10}
                              onChange={handleOpt10Change}
                            >
                              {!opt10 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>
                          {opt10 === "TAK" ? (
                            <>
                              <div className="inputCol_3">
                                <label>W jakim okresie?</label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  id="url"
                                  name="url"
                                  value={opt11}
                                  onChange={handleOpt11Change}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          style={{ marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>7. Czy jest rozdzielność majątkowa?</label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={opt12}
                              onChange={handleOpt12Change}
                            >
                              {!opt12 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                                <option
                                  key={"NIE DOTYCZY"}
                                  value={"NIE DOTYCZY"}
                                >
                                  NIE DOTYCZY
                                </option>
                              </>
                            </select>
                          </div>
                          {opt12 === "TAK" ? (
                            <>
                              <div className="inputCol_3">
                                <label>Od kiedy?</label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  id="url"
                                  name="url"
                                  value={opt13}
                                  onChange={handleOpt13Change}
                                />
                                <span style={{ fontSize: "0.7vw" }}>
                                  Prosimy o przesłanie dokumentu
                                  potwierdzającego rozdzielność majątkową i
                                  informację kto po jej ustanowieniu dokonuje
                                  spłat rat do banku
                                </span>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          style={{ marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>8. Czy jest wspólność majątkowa?</label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={opt23}
                              onChange={handleOpt23Change}
                            >
                              {!opt23 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                                <option
                                  key={"NIE DOTYCZY"}
                                  value={"NIE DOTYCZY"}
                                >
                                  NIE DOTYCZY
                                </option>
                              </>
                            </select>
                          </div>
                          {opt23 === "TAK" ? (
                            <>
                              <div className="inputCol_3">
                                <label>Od kiedy?</label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  id="url"
                                  name="url"
                                  value={opt24}
                                  onChange={handleOpt24Change}
                                />
                                <span style={{ fontSize: "0.7vw" }}>
                                  W przypadku powstania wspólności majątkowej po
                                  zawarciu umowy kredytu prosimy o przesłanie
                                  aktu małżeństwa oraz informację kto dokonywał
                                  płatności rat przed małżeństwem
                                </span>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          style={{ marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              9. Kto faktycznie spłacał kredyt? (dot. sytuacji,
                              gdy jest kilku kredytobiorców)
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={opt14}
                              onChange={handleOpt14Change}
                            >
                              {!opt14 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option
                                  key={"WSZYSCY KREDYTOBIORCY RAZEM"}
                                  value={"WSZYSCY KREDYTOBIORCY RAZEM"}
                                >
                                  WSZYSCY KREDYTOBIORCY RAZEM
                                </option>
                                <option
                                  key={"JEDEN KREDYTOBIORCA"}
                                  value={"JEDEN KREDYTOBIORCA"}
                                >
                                  JEDEN KREDYTOBIORCA
                                </option>
                              </>
                            </select>
                          </div>
                          {opt14 === "JEDEN KREDYTOBIORCA" ? (
                            <>
                              <div className="inputCol_3">
                                <label>Od kiedy?</label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  id="url"
                                  name="url"
                                  value={opt15}
                                  onChange={handleOpt15Change}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>

                        <div
                          style={{ marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              10. Czy pracowali Państwo w banku/instytucji
                              finansowej?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={opt16}
                              onChange={handleOpt16Change}
                            >
                              {!opt16 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"TAK"} value={"TAK"}>
                                  TAK
                                </option>
                                <option key={"NIE"} value={"NIE"}>
                                  NIE
                                </option>
                              </>
                            </select>
                          </div>

                          {opt16 === "TAK" ? (
                            <>
                              <div className="inputCol_2">
                                <div className="inputBox">
                                  <div
                                    style={{ width: "61%" }}
                                    className="inputCol_3"
                                  >
                                    <label>W jakim okresie?</label>
                                    <input
                                      className="textAreaNote"
                                      type="text"
                                      id="url"
                                      name="url"
                                      value={opt17}
                                      onChange={handleOpt17Change}
                                    />
                                  </div>
                                </div>
                                <div className="inputBox">
                                  <div
                                    style={{ width: "61%" }}
                                    className="inputCol_3"
                                  >
                                    <label>
                                      Czy była powiązana z kredytami walutowymi?
                                    </label>
                                    <input
                                      className="textAreaNote"
                                      type="text"
                                      id="url"
                                      name="url"
                                      value={opt25}
                                      onChange={handleOpt25Change}
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          style={{ marginBottom: "5vh" }}
                          className="inputBox"
                        >
                          <div className="inputCol_2">
                            <label>
                              11. W jakiej walucie spłacany był kredyt?
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={opt18}
                              onChange={handleOpt18Change}
                            >
                              {!opt18 ? (
                                <option key={0} value="0">
                                  Wybierz...
                                </option>
                              ) : (
                                ""
                              )}
                              <>
                                <option key={"PLN"} value={"PLN"}>
                                  PLN
                                </option>
                                <option key={"CHF"} value={"CHF"}>
                                  CHF
                                </option>
                              </>
                            </select>
                          </div>
                          {opt18 === "CHF" ? (
                            <>
                              <div className="inputCol_3">
                                <label>
                                  Od kiedy kredyt był spłacany w CHF?
                                </label>
                                <input
                                  className="textAreaNote"
                                  type="text"
                                  id="url"
                                  name="url"
                                  value={opt19}
                                  onChange={handleOpt19Change}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>

                        <>
                          <div className="saveBoxAP">
                            <button
                              style={{ minWidth: "25%", fontSize: "1.5vw" }}
                              className="paymentMenuButton"
                              onClick={addQuest}
                            >
                              {"Wyślij"}
                            </button>
                          </div>
                        </>
                      </div>
                    </>
                  )}
                </div>
              )}
            </>
          ) : (
            ""
          )}
        </>
      )}
    </div>
  );
};

export default AddQuestionnaireClient;
